import { useState } from "react"
import { Accordion } from "@prosolve/common-components-ui"
import styled from "styled-components"
import { checkHasEditJobsPermissions, checkHasReadJobsPermissions, getClientSubdomain, getIsProsolveSubdomain } from "../../utils"
import EventTrainerReminders from "./EventTrainerReminders"
import EventAttendeeReminders from "./EventAttendeeReminders"
import EventAttendeeCertificate from "./EventAttendeeCertificate"

const Container = styled.div`
  padding: 20px;
`

const Title = styled.div`
  color: #565656;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
`

const AccordionTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

const AccordionSubtitle = styled.div`
  color: gray;
`

export default () => {
  const clientSubdomain = getClientSubdomain()
  const isStarSubdomain = (clientSubdomain === 'star')
  const isProsolveSubdomain = getIsProsolveSubdomain()

  const [trainerReminders, setTrainerReminders] = useState()
  const [attendeeReminders, setAttendeeReminders] = useState()
  const [attendeeCertificates, setAttendeeCertificates] = useState()
  
  const hasRead = checkHasReadJobsPermissions()
  const hasEdit = checkHasEditJobsPermissions()

  return (
    !(hasRead || hasEdit)
    ?
    <div>Access Denied</div>
    :
    <Container>
      <Title>Jobs</Title>

      {isProsolveSubdomain &&
        <>
          <Accordion
            title={
              <AccordionTitle>
                <div>Trainer Event Reminders ({trainerReminders?.length ?? '...'})</div>
                <AccordionSubtitle>Emails will be sent to these users on the next run</AccordionSubtitle>
              </AccordionTitle>
            }
            headerExpands={true}
            style={{ background: "#ffffff", borderBottom: "1px solid #dcdcdc" }}
            expandedStyle={{ background: "#ffffff" }}
          >
            <EventTrainerReminders onLoad={r => setTrainerReminders(r)} />
          </Accordion>

          <Accordion
            title={
              <AccordionTitle>
                <div>Attendee Event Reminders ({attendeeReminders?.length ?? '...'})</div>
                <AccordionSubtitle>Emails will be sent to these users on the next run</AccordionSubtitle>
              </AccordionTitle>
            }
            headerExpands={true}
            style={{ background: "#ffffff", borderBottom: "1px solid #dcdcdc" }}
            expandedStyle={{ background: "#ffffff" }}
          >
            <EventAttendeeReminders onLoad={r => setAttendeeReminders(r)} />
          </Accordion>
        </>
      }

      {isStarSubdomain &&
        <>
          <Accordion
            title={
              <AccordionTitle>
                <div>Attendee Event Certificates ({attendeeCertificates?.length ?? '...'})</div>
                <AccordionSubtitle>Emails will be sent to these users on the next run</AccordionSubtitle>
              </AccordionTitle>
            }
            headerExpands={true}
            style={{ background: "#ffffff", borderBottom: "1px solid #dcdcdc" }}
            expandedStyle={{ background: "#ffffff" }}
          >
            <EventAttendeeCertificate onLoad={r => setAttendeeCertificates(r)} />
          </Accordion>
        </>
      }
    </Container>
  )
}
